import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../Axios/AxiosInstance';
import { useLocation } from 'react-router-dom';
import Header from '../../../Components/Header/Header';
import Footer from '../../../Components/Footer/Footer';
import { TableTextConstants, TextConstants } from '../../../Constants/Constants';
import ReusableTable from '../../../Components/Table/ReusableTable';

const Product = () => {
  
  const { dealerId, painterId } = useParams();
  const location = useLocation();
  const { scannedDate,painterName,painterMobile } = location.state || {};

  const [painterData, setPainterData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); 
  const [isLoading, setIsLoading] = useState(true); 
  const [totalRecords, setTotalRecords] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]); 
  const pageDataRef = useRef({});

  const convertDateFormat = (dateStr) => {
    if (!dateStr) return '';

    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  };

  const formattedDate = convertDateFormat(scannedDate);

  useEffect(() => {
    fetchPainterData();
  }, [dealerId, painterId,rowsPerPage,currentPage]);

  const fetchPainterData = async () => {
    const cacheKey = `${currentPage}-${rowsPerPage}`;
    if (pageDataRef.current[cacheKey]) {
      setPainterData(pageDataRef.current[cacheKey]);
    } else {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post('admindashboard/DashBordDataListByPainter', {
          fromDate: formattedDate,
          toDate: formattedDate,
          dealerId: parseInt(dealerId),
          painterId: parseInt(painterId),
          searchItem: "",
          pageNumber: currentPage,
          pageSize: rowsPerPage,
        });
  
        const { dataListByPainter, paginatedData } = response.data;
  
        if (dataListByPainter && Array.isArray(dataListByPainter)) {
          const formattedData = dataListByPainter.map(item => {
            const formattedScannedDate = item.scannedDate ? new Date(item.scannedDate).toLocaleDateString('en-GB') : 'N/A';
            return {
              scannedDate: formattedScannedDate,
              productName: item.productName,
              qrCode: item.qrCode,
              processOrderNumber: item.processOrderNumber,
              totalAmount: item.totalAmount,
              schemeAmount: item.schemeAmount,
              handlingCharges: item.handlingCharges,
              totalFinalAmount: item.totalFinalAmount,
            };
          });
          setPainterData(formattedData);
          setTotalRecords(paginatedData.totalRecords);
          pageDataRef.current[cacheKey] = formattedData;
        } else {
          console.error('Data format is incorrect or missing:', dataListByPainter);
        }
      } catch (error) {
        console.error('Error fetching dealer data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const columns = [
    { key: "scannedDate", label: "Date" },
    { key: "productName", label: "Product Name" },
    { key: "qrCode", label: "Qr Code" },
    { key: "processOrderNumber", label: "Process Order Number" },
    { key: "totalAmount", label: "Amount", isTextAlignRight: true, isCurrency: true },
    { key: "schemeAmount", label: "Scheme Amount", isTextAlignRight: true, isCurrency: true },
    { key: "handlingCharges", label: "Handling Fee", isTextAlignRight: true, isCurrency: true },
    { key: "totalFinalAmount", label: "Total Amount", isTextAlignRight: true, isCurrency: true},
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows); 
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);  
    setCurrentPage(1); 
  };


  return (
    <div className="flex flex-col min-h-screen">
      <Header title={"Product Details"}/>

      <div className="flex flex-col flex-1 mx-2 my-3">
        
      <div className="flex justify-between">
        <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
          <span className="text-md">
            {TableTextConstants.painterName}: {painterName}
          </span>
        </div>
        <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
          <span className="text-md">
            {TableTextConstants.paintermobile}: {painterMobile}
          </span>
        </div>
      </div>

      <div className="mt-3 p-1">
          <ReusableTable
            data={painterData}
            columns={columns}
            rowsPerPage={rowsPerPage}
            loading={isLoading}
            currentPage={currentPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSelectedRowsChange={handleSelectedRowsChange}
          />
        </div>

    </div>

      <Footer/>
    </div>
  );
};

export default Product;
